var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.182 3.142A1.5 1.5 0 0 1 3.2 2.75h2.897l1.857 1.688.143.13H12.8a1.5 1.5 0 0 1 1.018.392c.274.254.432.602.432.97v5.959c0 .367-.158.715-.432.969a1.5 1.5 0 0 1-1.018.392H3.2a1.5 1.5 0 0 1-1.018-.392l-.34.366.34-.366a1.32 1.32 0 0 1-.432-.97V4.112c0-.367.158-.715.432-.969Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderFilled);
export default ForwardRef;